import React, { PureComponent, Fragment } from 'react'
import styles from './Consent.scss'
import Title from './Title'
export default class Consent extends PureComponent {
  render() {
    return (
      <Fragment>
        <style jsx>{styles}</style>
        <div className="consent">
          <Title>注意事項</Title>
          <ol>
            <li>未成年（未滿20歲）之人，須得法定代理人同意後始得參與本活動。</li>
            <li>
              報名者自PopDaily官網填妥報名資料後，即可參加PopDaily創作者招募徵選。PopDaily將主動聯繫入選之報名者，未入選者將不再個別通知。
            </li>
            <li>
              報名者保證所提供的報名資料均為報名者本人的真實資料，不得有任何偽造或冒用他人資料之情形。
            </li>
            <li>
              若因報名者未提供正確資訊或未詳細填寫聯絡資訊，導致PopDaily無法以任何一種方式聯絡報名者時，即視同放棄入選資格，PopDaily不負相關責任。
            </li>
            <li>
              報名者得自由選擇是否提供相關個人資料，但若未能提供本活動要求之完整資料，影響參與本次活動之權益。
            </li>
            <li>
              報名者於報名時所填寫之資料，僅供本活動初選時使用於篩選資格、聯絡、公告、後續處理及記錄之用途，並於報名結束後，PopDaily將刪除未入選之資料除；入選者之資料將轉入PopDaily資料庫，並妥善維護。
            </li>
            <li>
              參加者報名本活動時，即視為同意接受本活動規範，也同意PopDaily收集、利用與處理相關個人資料。倘參加者有違反本活動相關注意事項與規範者，經PopDaily發現或者第三人檢舉並查核後，PopDaily得立即取消該參加者之資格，並由參加者自負相關法律責任。
            </li>
            <li>
              本活動所蒐集個人資料，PopDaily會遵守個人資料保護法、PopDaily服務條款、PopDaily隱私政策等規定，以維護參加者權益。
            </li>
            <li>
              參加者經PopDaily入選成為本活動之創作者，同意於PopDaily平台發布之所有著作（包括但不限於文字、照片、影音等）授權予
              PopDaily使用於全球地區，且使用方式不限於公開展示、公開播送、公開傳輸、公開上映、公開演出、散布等。但創作者應保證其著作無侵犯第三人之權利或任何違法事由，若有侵權或違法事由，應由創作者自負相關法律責任。
            </li>
            <li>
              PopDaily保有本活動最終解釋權，並保留隨時修改、補充活動辦法，及隨時暫停或終止本活動之一切權利。若有任何更動，將於活動網頁中公佈相關內容，恕不另行通知。
            </li>
            <li>若進行文章刪除的動作，流量終止計算，將影響收益。</li>
            <li>如對本活動辦法與相關參與方式有任何疑問，歡迎來信 creators@sugoigroup.tw</li>
          </ol>
        </div>
      </Fragment>
    )
  }
}
